<template>
  <span v-if="showAuthorPendingMessage" style="color: #6b7280">
    Not visible, pending moderation.
  </span>
  <span v-if="showAuthorBlockedMessage" style="color: #6b7280">
    This message has been blocked.
  </span>
  <div v-if="isModerator && moderationEnabled" style="display: flex; justify-content: space-between; width: 100%">
    <span style="color: #3b82f6">
      Report Count: {{ numReports }}
    </span>
    <span style="color: #3b82f6">
      moderation score: {{ moderationScore }}
    </span>
  </div>
</template>

<script>
import { mapActions } from "pinia";
import { useMessageStore } from "%/apps/conversations/stores/message-store";

export default {
  name: "ModerationInfo",
  props: {
    messageId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    message() {
      return this.getMessage(this.messageId);
    },
    isAuthor() {
      return this.isMessageAuthor(this.messageId);
    },
    moderationEnabled() {
      // TODO: This should come from conversation settings
      return false;
    },
    isModerator() {
      // TODO: This should check actual moderator status
      return false;
    },
    showAuthorPendingMessage() {
      return this.isAuthor && this.message.moderationStatus === "unknown";
    },
    showAuthorBlockedMessage() {
      return this.isAuthor && this.message.moderationStatus === "blocked";
    },
    numReports() {
      return this.message.numReports || 0;
    },
    moderationScore() {
      return this.message.moderationScore || 0;
    },
  },
  methods: {
    ...mapActions(useMessageStore, ["getMessage", "isMessageAuthor"]),
  },
};
</script>

<style scoped>

</style>
